import { Box } from '@pocketlaw/tetris';
import { ApprovalCheckError } from './ApprovalCheckError';
import { useApprovalCheck } from './ApprovalCheckProvider';
import { EvaluatingState } from './EvaluatingState';
import { ReviewState } from './ReviewState';
import { WorkflowApproversProvider } from './WorkflowApproversProvider';
import { WorkflowInitialState } from './WorkflowInitialState';
export function RequestVoluntaryAdvanced() {
    const { startCheck, state } = useApprovalCheck();
    const handleSelectWorkflow = (workflowId) => {
        startCheck(workflowId);
    };
    if (state === 'done') {
        return (<WorkflowApproversProvider>
        <ReviewState />
      </WorkflowApproversProvider>);
    }
    return (<Box flexDirection="column" p="xl" height="100%">
      <ApprovalCheckError />

      {state === 'initial' && <WorkflowInitialState onSelectWorkflow={handleSelectWorkflow}/>}

      {state === 'evaluating' && <EvaluatingState />}
    </Box>);
}
